var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03809 0.957886C2.53027 0.957886 0.538086 2.99695 0.538086 5.45789C0.538086 7.14539 1.07715 7.66101 4.07715 12.4423C4.52246 13.1454 5.53027 13.1454 5.97559 12.4423C8.97559 7.66101 9.53809 7.14539 9.53809 5.45789C9.53809 2.97351 7.49902 0.957886 5.03809 0.957886ZM5.03809 11.8329C2.03809 7.05164 1.66309 6.74695 1.66309 5.45789C1.66309 3.60632 3.16309 2.08289 5.03809 2.08289C6.88965 2.08289 8.41309 3.60632 8.41309 5.45789C8.41309 6.74695 8.03809 7.00476 5.03809 11.8329ZM3.16309 5.45789C3.16309 6.51257 3.9834 7.33289 5.03809 7.33289C6.06934 7.33289 6.91309 6.51257 6.91309 5.45789C6.91309 4.42664 6.06934 3.58289 5.03809 3.58289C3.9834 3.58289 3.16309 4.42664 3.16309 5.45789Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map-icon.675c4c6da4f5aab4565794e19cf2825d.svg";
export { ForwardRef as ReactComponent };